import React from 'react';

import FitQuizController from '../apps/fitQuiz/FitQuizController';
import PageSEO from '../components/common/PageSEO/PageSEO';
import Layout from '../components/layout';

const FitQuiz = () => {
  return (
    <PageSEO
      description="See if Hometap is a good fit by taking our quiz!"
      title="Fit Quiz"
      canonicalUrl="https://www.hometap.com/fit-quiz"
      opengraphTitle="Hometap | Is Hometap right for me?"
      opengraphDescription="See if Hometap is a good fit by taking our quiz!"
    >
      <Layout>
        <FitQuizController />
      </Layout>
    </PageSEO>
  );
};

export default FitQuiz;
